import api from "./api";

export const getActivities = (customerId) => {
  return api.get("/v1/crm/activities?customerId=" + customerId);
};
